import React from 'react'
import { Box, Button, TextField, Paper, FormControl, InputLabel, Select, MenuItem, FormControlLabel, Checkbox, Typography } from '@mui/material'
import { Grid } from '@mui/material'
import { router, usePage, useForm } from '@inertiajs/react'
import AppShell from '../../../../components/layout/AppShell'
import PageHeader from '../../../../components/ui/PageHeader'

Form.layout = (page) => <AppShell>{page}</AppShell>

export default function Form({ property, fiscal_year, charts_of_accounts = [], last_fiscal_year = null, action, errors: serverErrors = {} }) {
  const { props } = usePage()
  const tenant = props.tenant || {}
  const isEdit = action === 'edit'
  const basePath = `/m/${tenant.slug}/properties/${property.id}`

  const { data, setData, post, put, processing, errors } = useForm({
    start_date: fiscal_year.start_date || '',
    end_date: fiscal_year.end_date || '',
    chart_of_accounts_id: fiscal_year.chart_of_accounts_id || '',
    create_new_chart: false,
  })

  const allErrors = { ...serverErrors, ...errors }

  const handleSubmit = (e) => {
    e.preventDefault()
    const payload = { fiscal_year: { start_date: data.start_date, end_date: data.end_date, chart_of_accounts_id: data.chart_of_accounts_id }, create_new_chart: data.create_new_chart ? '1' : '0' }
    if (isEdit) {
      router.put(`${basePath}/fiscal_years/${fiscal_year.id}`, payload)
    } else {
      router.post(`${basePath}/fiscal_years`, payload)
    }
  }

  return (
    <Box>
      <PageHeader
        title={isEdit ? 'Geschäftsjahr bearbeiten' : 'Neues Geschäftsjahr'}
        breadcrumbs={[
          { label: property.name, href: basePath },
          { label: 'Geschäftsjahre', href: `${basePath}/fiscal_years` },
          { label: isEdit ? 'Bearbeiten' : 'Neu' },
        ]}
      />

      <Paper elevation={0} sx={{ p: 3, border: '1px solid', borderColor: 'divider', maxWidth: 600 }}>
        {!isEdit && last_fiscal_year && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }} data-testid="prefill-hint">
            Basierend auf Geschäftsjahr {last_fiscal_year.start_date} – {last_fiscal_year.end_date}
          </Typography>
        )}
        <Box component="form" onSubmit={handleSubmit} data-testid="fiscal-year-form">
          <Grid container spacing={2}>
            <Grid size={{ xs: 12 }}>
              <TextField label="Beginn" type="date" required fullWidth size="small"
                value={data.start_date} onChange={(e) => setData('start_date', e.target.value)}
                error={!!allErrors.start_date} helperText={allErrors.start_date?.[0]}
                slotProps={{ inputLabel: { shrink: true } }}
                data-testid="start-date-input" />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField label="Ende" type="date" required fullWidth size="small"
                value={data.end_date} onChange={(e) => setData('end_date', e.target.value)}
                error={!!allErrors.end_date} helperText={allErrors.end_date?.[0]}
                slotProps={{ inputLabel: { shrink: true } }}
                data-testid="end-date-input" />
            </Grid>
            {!isEdit && (
              <Grid size={{ xs: 12 }}>
                <FormControlLabel
                  control={<Checkbox checked={data.create_new_chart} onChange={(e) => setData('create_new_chart', e.target.checked)} />}
                  label="Neuen Kontenplan aus SKR 49 erstellen"
                  data-testid="create-chart-checkbox"
                />
              </Grid>
            )}
            {!data.create_new_chart && (
              <Grid size={{ xs: 12 }}>
                <FormControl fullWidth size="small" required={!data.create_new_chart} error={!!allErrors.chart_of_accounts_id}>
                  <InputLabel>Kontenplan</InputLabel>
                  <Select value={data.chart_of_accounts_id} label="Kontenplan"
                    onChange={(e) => setData('chart_of_accounts_id', e.target.value)}
                    data-testid="chart-select">
                    {charts_of_accounts.map((c) => (
                      <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            )}
          </Grid>
          <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
            <Button type="submit" variant="contained" disabled={processing} data-testid="submit-btn">
              {processing ? 'Wird gespeichert...' : 'Speichern'}
            </Button>
            <Button variant="outlined" onClick={() => router.visit(`${basePath}/fiscal_years`)}>Abbrechen</Button>
          </Box>
        </Box>
      </Paper>
    </Box>
  )
}
